let productInfo;

const buyBarFixed = document.querySelector('.buy-bar-button');
const buyBar = document.querySelector('.hero-buyBar-button-lg');
const mobileBuyBar = document.querySelector('.hero-buyBar-button');

const items = [buyBar, buyBarFixed, mobileBuyBar];

fetch(window.Shopify.routes.root + location.pathname.replace('/', '') + '.js')
.then(response => response.json())
.then((productData) => {
  productInfo = productData;
})

items.forEach((button) => {
  if (button) {
    button.addEventListener('click', (event) => {
      const isParent = productInfo.title === productInfo.type;
      const isReplen = productInfo.tags.includes('replen');
      const isSet = productInfo.type === 'Sets';
      const shouldAddToCart = !isParent && !isReplen && !isSet;
      if (shouldAddToCart && 'liquidAjaxCart' in window) {
        const activeVariantElement = document.querySelector('.hero-carousel-custom-pagination-item[data-active="true"]');
    
        if (activeVariantElement) {
          const variantId = activeVariantElement.getAttribute('data-variant');
    
          liquidAjaxCart.cartRequestAdd({
            items: [
              {
                id: variantId,
                quantity: 1,
              }
            ]
          })
        } else {
          liquidAjaxCart.cartRequestAdd({
            items: [
              {
                id: productInfo.variants[0].id,
                quantity: 1,
              }
            ]
          })
        }
    
        const lottieContainer = document.querySelector(".three-dots-lottie");
        
        lottie.loadAnimation({
          container: lottieContainer, 
          renderer: "svg",
          loop: true,
          autoplay: true,
          path: "https://cdn.shopify.com/s/files/1/0648/9384/5739/files/three-dots-lottie.json?v=1659728191",
          name: "loader"
        });
    
        event.currentTarget.style.pointerEvents = 'none';
        event.currentTarget.querySelector('p').style.opacity = 0;
        event.currentTarget.appendChild(lottieContainer);
    
        lottieContainer.style.display = 'block';
      }
    });
  }
})

const PICK_YOUR_PLAN_NUMBER_INTERVAL = 5000;

const DEFFAULT_NUMBERS = {
  6: 0,
  9: 1,
  3: 2,
};

let MAPPED_NUMBERS_TO_INDEXES;

if(Object.keys(NUMBERS_FROM_SHOPIFY).length > 1){
  MAPPED_NUMBERS_TO_INDEXES = NUMBERS_FROM_SHOPIFY;
} else {
  MAPPED_NUMBERS_TO_INDEXES = DEFFAULT_NUMBERS;
}

const ArrayNumberOfPlans = Object.keys(MAPPED_NUMBERS_TO_INDEXES);

const COLORS_MAP_OBJECT = {};

//Create colors map object
if (ArrayNumberOfPlans) {
  const colors = ["#FF8B50","#24AE87", "#87CAD7"];
  colors.forEach((element, index) => {
    COLORS_MAP_OBJECT[ArrayNumberOfPlans[index]] = element;
  });
} else {
  COLORS_MAP_OBJECT = null;
}
  
const numberReadyCallback = () => {
  const pickYourPlanBottomSection = document.querySelector('.pick-your-replen-plan-bottom');
  const plans = Array.from(pickYourPlanBottomSection.querySelectorAll('.pick-your-replen-plan-item'));
  let number = ArrayNumberOfPlans[1];
  pickYourPlanBottomSection.appendChild(animatedNumber.init(number));
  plans[MAPPED_NUMBERS_TO_INDEXES[number]].classList.add('pick-your-replen-plan-item--active');
  animatedNumber.animate(number);

  let iterator = 1;
  numbersSwitchInterval = setInterval(() => {
     ++iterator;
    if (iterator >= ArrayNumberOfPlans.length) {
        iterator = 0;
    }
    plans.forEach((plan) => plan.classList.contains('pick-your-replen-plan-item--active') && plan.classList.remove('pick-your-replen-plan-item--active'));
    
    number = ArrayNumberOfPlans[iterator];
    const activePlan = plans[MAPPED_NUMBERS_TO_INDEXES[number]];
    activePlan.classList.add('pick-your-replen-plan-item--active');
    animatedNumber.animate(number);
  }, PICK_YOUR_PLAN_NUMBER_INTERVAL);
}


const animatedNumber = new AnimatedNumber(COLORS_MAP_OBJECT, numberReadyCallback);